<template>
	<div style="padding-top: 8px" id="notes-div">
		<vue-drawing-canvas
			ref="canvas"
			:width="width"
			:height="height"
			:initial-image="initialImage"
			:image.sync="image"
			line-join="round"
			line-cap="round"
			save-as="png"
			classes="border border-gray-300"
			color="#284283"
		/>
		<div style="height: 62px;">
			<p>{{$t('notes.note')}}</p>
			<button class="btn btn-danger" @click="clear()">
				<font-awesome-icon icon="eraser"/>
				{{ $t('notes.clear') }}
			</button>
		</div>
	</div>
</template>

<script>
import VueDrawingCanvas from "vue-drawing-canvas/dist/vue-drawing-canvas.esm";
export default {
	name: 'NotesDraw',
	components: {
		"vue-drawing-canvas": VueDrawingCanvas,
	},
	data() {
		return {
			image: "",
			initialImage: [],
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight,
		};
	},
	computed: {
		width() {
			return this.windowWidth;
		},
		height() {
			return Math.max(this.windowHeight - (this.windowWidth <= 340 ? 320 : 300), 300);
		},
	},
	mounted() {
		this.initialImage = JSON.parse(window.consentedStorage.getItem('notes-drawing'));
		this.$refs.canvas.redraw();
		this.updateCanvasSize();
		window.addEventListener('resize', this.updateCanvasSize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateCanvasSize);
		// Logout clears auth token before route teardown; skip autosave in that case.
		if (!window.consentedStorage.getItem('loggedInUserToken')) {
			return;
		}
		window.consentedStorage.setItem('notes-drawing', JSON.stringify(this.$refs.canvas.getAllStrokes()));
	},
	methods: {
		updateCanvasSize() {
			this.windowWidth = document.getElementById("notes-div").offsetWidth;
			this.windowHeight = window.innerHeight;
			this.$refs.canvas.redraw();
		},
		clear() {
			this.$refs.canvas.reset();
			this.image = "";
		}
	}
}
</script>

<style scoped>

</style>
